<template>
	<div id="large-navbar">
		<div class="container">
			<div class="row navbar-row-top d-flex align-items-center">
				<div class="col-3 navbar-logo">
					<router-link to="/"><img class="navbar-logo" src="/images/logos/bb-logo-text.svg" /></router-link>
				</div>
				<div class="col-lg-9 col-md-9">
					<div class="buttons-row w-100 d-flex align-items-center justify-content-end">
						<base-button
							class="buy-ebso"
							type="light-green"
							:text="$t('globals.navigation.buyEbso')"
							@clicked="handleBuyEbso"
						/>
						<dropdown-button
							class="dropdown"
							icon="bb-sphere"
							:text="'Button Text'"
							type="secondary"
							size="small"
							selectText="shortLabel"
							optionText="label"
							selectValue="value"
							:options="languageOptions"
							:value="selectedValue"
							@input="languageSelected"
						></dropdown-button>
<!-- 
						<base-button class="registration" :type="'secondary'"
							:text="$t('globals.navigation.profile.login')" @clicked="handleNavbarBtnClick('login')" />
						<base-button class="login" :text="$t('globals.navigation.profile.registration')"
							@clicked="handleNavbarBtnClick('registration')" /> -->
					</div>
				</div>
			</div>
			<div class="row navbar-row-bottom d-flex align-items-center">
				<div class="col-lg-12 col-md-12">
					<ul class="navigation">
						<template v-for="(item, i) in navigations">
							<li v-if="!item.subItems" :key="i" class="navigation-item">
								<router-link v-if="!item.link.includes('https')" :to="item.link">{{ $t(item.titleKey)
									}}</router-link>
								<a v-else :href="item.link" target="_blank">{{
									$t(item.titleKey)
								}}</a>
							</li>
							<li v-else :key="`parent-${i}`" class="navigation-item has-child" :data-group-id="item.groupId">
								<span class="parent">{{ $t(item.titleKey) }} <i class="bb-arrow-down"></i></span>
								<navbar-dropdown :items="item.subItems" />
							</li>
						</template>
						<span class="navigation-indicator"
							:style="`left: ${indicatorXPos}px; width: ${indicatorWidth}px`" />
					</ul>
				</div>
			</div>
		</div>
		<div>
			<exchange-row />
<!-- 			<fee-row /> -->
			<ebso-info-row v-if="$route.path.includes('/products/ebso')" />			
			<holoverz-info-row v-if="$route.path.includes('/products/holoverz')" />		
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ExchangeRow from './ExchangeRow';
//import FeeRow from "@/components/modules/navbars/FeeRow.vue";
import EbsoInfoRow from "@/components/modules/navbars/EbsoInfoRow.vue";
import HoloverzInfoRow from "@/components/modules/navbars/HoloverzInfoRow.vue";

const NavbarDropdown = () => import('@/components/elements/NavbarDropdown');

export default {
	name: 'LargeNavbar',
	props: {
		navigations: {
			type: Array,
			required: true,
		},
		defaultLanguage: {
			type: Object,
			required: false,
		},
		languageOptions: {
			type: Array,
			required: false,
		},
		navbarHeight: {
			type: String,
			default: '92px',
		},
	},
	components: {
		ExchangeRow,
		//FeeRow,
		EbsoInfoRow,
		HoloverzInfoRow,
		NavbarDropdown,
	},
	data: () => ({
		indicatorXPos: 0,
		indicatorWidth: 0,
		selectedValue: undefined,
		buyEbsoUrl: 'https://www.lbank.com/trade/ebso_usdt',
	}),
	created() { },
	computed: {
		...mapGetters({
			getSelectedLanguage: 'settings/getSelectedLanguage',
		}),
	},
	watch: {
		defaultLanguage: {
			immediate: true,
			handler() {
				this.selectedValue = this.defaultLanguage;
			},
		},
		$route(to, from) {
			setTimeout(() => {
				this.setIndicatorPosition(to.path);
			});
		},
		getSelectedLanguage: {
			immediate: true,
			handler() {
				setTimeout(() => {
					this.setIndicatorPosition(this.$route.path);
				});
			},
		},
	},
	methods: {
		...mapActions({
			setSelectedLanguage: 'settings/setSelectedLanguage',
		}),
		handleBuyEbso() {
			window.open(this.buyEbsoUrl, '_blank');
		},
		languageSelected(e) {
			this.selectedValue = e;
			this.setSelectedLanguage(this.selectedValue);
			this.$router.push({
				name: this.$route.name,
				params: { lang: this.selectedValue },
			});
		},
		handleNavbarBtnClick(type) {
			if (type === 'login') {
				window.open('https://wallet.blockben.com/login', '_blank');
			} else if (type === 'registration') {
				window.open('https://wallet.blockben.com/register', '_blank');
			}
		},
		setIndicatorPosition(route) {
			let parsedRoute = route.split('/');
			parsedRoute = parsedRoute[parsedRoute.length - 1];

			let activeItem = null;
			let foundGroupId = null;

			// A route that also has its own top level entry (eBSO) should mark
			// that entry, not the dropdown that happens to list it too.
			const hasTopLevelEntry = this.navigations.some(
				navItem =>
					!navItem.subItems &&
					navItem.link &&
					navItem.link.includes(parsedRoute)
			);

			// Find which group the route belongs to in the navigation array
			if (!hasTopLevelEntry) {
				for (let navItem of this.navigations) {
					if (navItem.subItems) {
						// Check whether the route is included in the subItems
						const foundInSubItems = navItem.subItems.some(subItem =>
							subItem.link && subItem.link.includes(parsedRoute)
						);
						if (foundInSubItems) {
							foundGroupId = navItem.groupId;
							break;
						}
					}
				}
			}
			// If a groupId was found, find the parent element based on it
			if (foundGroupId) {
				activeItem = document.querySelector(`.navigation-item.has-child[data-group-id="${foundGroupId}"]`);
			} else {
				activeItem = document.querySelector(
					`.navigation-item a[href*="${parsedRoute}"]`,
				);
			}
			this.indicatorWidth = activeItem ? activeItem.offsetWidth : 0;
			this.indicatorXPos = activeItem ? activeItem.offsetLeft : 0;
		},
	},
};
</script>

<style lang="scss" scoped>
@keyframes fadeIn {
	1% {
		transform: scale(1);
		opacity: 0;
	}

	100% {
		transform: scale(1);
		opacity: 1;
	}
}

#large-navbar {
	// $desktopHeight: 92px;
	$desktopNavigationHeight: 66px;
	background: #e8e8ff;

	.container {
		max-width: 1196px !important;
	}

	.navbar-row-top {
		padding-top: 37px;
		// min-height: $desktopHeight;
	}

	.navbar-row-bottom {
		min-height: $desktopNavigationHeight;
	}

	.navbar-logo {
		max-height: 38px;
	}

	.registration {
		background: #e8e8ff;
	}

	.buy-ebso {
		margin-right: 20px;
		white-space: nowrap;
	}

	::v-deep .secondary {
		background: #e8e8ff;
	}

	::v-deep .default.open {
		background: $primary-purple-dark;
	}

	.navigation {
		display: flex;
		align-items: center;
		list-style-type: none;
		margin: 0;
		padding: 0;
		position: relative;
		height: $desktopNavigationHeight;
		// was 160px, which only fitted five items -- eBSO and Blog pushed the
		// labels into wrapping
		gap: 100px;

		@media screen and (max-width: 1200px) {
			gap: 24px;
			justify-content: space-between;
		}

		.navigation-indicator {
			display: inline-block;
			width: 67px;
			height: 8px;
			background-color: $black;
			position: absolute;
			bottom: 0px;
			transition: $transition-global;
		}

		.navigation-item {
			// only the top level labels; the dropdown lives inside this li and
			// its descriptions must stay wrappable
			> a,
			> .parent {
				white-space: nowrap;
			}

			a {
				font-size: 13px;
				font-family: 'HKNova', sans-serif;

				&:hover {
					text-decoration: none;
					color: #4656ff;
				}
			}

			&.has-child {
				position: relative;

				&:hover {
					.navbar-dropdown {
						animation: fadeIn 0.3s ease-out forwards;
					}

					.parent {
						color: $link-hover-color;
					}
				}

				.navbar-dropdown {
					position: absolute;
					top: 100%;
					transform: scale(0);
					opacity: 0;
					padding: 22px 0 0;
					z-index: 10;
				}

				.parent {
					font-size: 14px;
					font-weight: 700;
					color: $primary-purple;
					cursor: pointer;
					transition: $transition-global;
					display: flex;
					align-items: center;

					i {
						font-weight: 700;
						font-size: 8px;
						padding: 2px 0 0 9px;
					}
				}
			}
		}
	}

	.buttons-row {
		gap: 15px;
	}
}

@media (max-width: 1200px) {

	.registration,
	.login {
		display: none;
	}
}

@media (max-width: 880px) {
	.navigation {
		// max-width: 660px;
	}
}
</style>
